<template>
  <header class="header">
    <nav class="nav">
      <div class="nav-container">
        <RouterLink to="/" class="logo">
          <img src="/KK-logo.gif" alt="Keramicke Kondenzatory a.s." class="logo-image" />
        </RouterLink>
        
        <button
          class="mobile-menu-toggle"
          @click="toggleMobileMenu"
          :aria-expanded="isMobileMenuOpen"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        
        <ul class="nav-links" :class="{ 'mobile-open': isMobileMenuOpen }">
          <li>
            <RouterLink to="/" @click="closeMobileMenu">Home</RouterLink>
          </li>
          <li>
            <RouterLink to="/products" @click="closeMobileMenu">Products</RouterLink>
          </li>
          <li>
            <RouterLink to="/team" @click="closeMobileMenu">Team</RouterLink>
          </li>
          <li>
            <RouterLink to="/contact" @click="closeMobileMenu">Contact</RouterLink>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { RouterLink } from 'vue-router'

const isMobileMenuOpen = ref(false)

function toggleMobileMenu() {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}

function closeMobileMenu() {
  isMobileMenuOpen.value = false
}
</script>

<style scoped>
.header {
  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-secondary) 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  position: sticky;
  top: 0;
  z-index: 100;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 4rem;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25rem;
  font-weight: 700;
  text-decoration: none;
  color: var(--color-heading);
}

.logo-image {
  height: 3.25rem;
  width: auto;
}

.logo-icon {
  font-size: 1.5rem;
}

.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  gap: 0.25rem;
}

.mobile-menu-toggle span {
  width: 1.5rem;
  height: 2px;
  background: var(--color-text);
  transition: all 0.3s ease;
}

.nav-links {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 2rem;
}

.nav-links a {
  text-decoration: none;
  color: #2c3e50;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.nav-links a:hover,
.nav-links a.router-link-active {
  color: #1a1a1a;
  background: rgba(255, 255, 255, 0.3);
}

@media (max-width: 768px) {
  .mobile-menu-toggle {
    display: flex;
  }
  
  .nav-links {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-secondary) 100%);
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    flex-direction: column;
    padding: 1rem;
    gap: 0;
    transform: translateY(-100%);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
  }
  
  .nav-links.mobile-open {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }
  
  .nav-links li {
    margin: 0;
  }
  
  .nav-links a {
    display: block;
    padding: 1rem;
    border-radius: 0;
    border-bottom: 1px solid var(--color-border);
  }
  
  .nav-links a:last-child {
    border-bottom: none;
  }
}
</style>
